import {initWebComponent} from "@/helpers/web-component-helper";
import {setActiveFilter} from "@/helpers/filter/filter-helper";
import {setActiveMutation} from "@/helpers/tools/tools-mutation-helper";
import {hideLayerInfoForm, initHideButton} from "@/helpers/layer/info/layer-info-helper";
import {showHideDomainListItems, showHideLayerGroups} from "@/helpers/context-menu-helper.js";

const template = document.createElement('template');
template.innerHTML = `
<label class="custom-control custom-checkbox divCheckCategories">
        <input type="checkbox" class="custom-control-input checkbox-group-item spnCheckCategories">
        <span class="custom-control-label"></span>
</label>
`;

export class LayerMenuButtonCheck extends HTMLElement {
    constructor() {
        super();
        initWebComponent(this, template)

        this.addEventListener('click', (e) => {
            if(e.target.classList.contains('spnCheckCategories')) {

                if(e.target.checked) {
                    showHideDomainListItems(e)
                } else {
                    showHideDomainListItems(e, false)
                }
            }
        })
    }
}
